import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import {Router} from '@angular/router';
import {SessionStorageService} from '../../core/services/session-storage.service';
import {SubscriptionService, SubscriptionPlan} from '../../api/subscription.service';
import {storageKey} from '../../api/enum/storage.constants';

interface Plan {
  id: number;
  name: string;
  description: string;
  price: string;
  features: string[];
  note: string | null;
  isFeatured: boolean;
}

@Component({
  selector: 'app-subscription',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgIf],
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.scss'
})
export class SubscriptionComponent implements OnInit {

  subscriptionForm: FormGroup;
  selectedPlanName: string | null = null;
  plans: Plan[] = [];
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private storage: SessionStorageService,
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {
    this.subscriptionForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.subscriptionService.getPlans().subscribe({
      next: (response) => {
        this.plans = response.data.plans.map((p: SubscriptionPlan) => ({
          id: p.id,
          name: p.name,
          description: p.description,
          price: String(p.yearly_price),
          features: p.features ?? [],
          note: p.note ?? null,
          isFeatured: p.is_featured,
        }));
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  selectPlan(planName: string): void {
    this.selectedPlanName = planName;
  }

  backToInstituteInfo(): void {
    this.router.navigateByUrl('/institute');
  }

  submit(): void {
    if (!this.selectedPlanName) return;
    const selectedPlan = this.plans.find(p => p.name === this.selectedPlanName);
    if (selectedPlan) {
      this.storage.set(storageKey.subscriptionData, {
        id: selectedPlan.id,
        plan: selectedPlan.name,
        price: `₹${selectedPlan.price}/Student/Year`,
      });
    }
    this.router.navigateByUrl('/summary');
  }
}
